import React, {useRef, useEffect, useState, useCallback} from 'react';
import './VideoPlayer.css';



const VideoPlayer = (props) => {
  const videoElement = useRef();
  const [previousUrl, setPreviousUrl] = useState(null);
  const [volume, setVolume] = useState(0);


  useEffect(() => {
    videoElement.current.volume = volume;
  }, [volume])



  useEffect(() => {
    console.log("ESE EFFECT VIDEO", props, videoElement)
    if (props.video && previousUrl !== props.video.link) {
      videoElement.current.load();
      videoElement.current.play();
      setVolume(0)
      setPreviousUrl(props.video.link);
    }
  }, [props.video]);


  useEffect(() => {
    console.log("ESE EFFECT PLAYING",props, videoElement)
    if (props.isPlaying) {
      setVolume(1)
      videoElement.current.currentTime = 0;
    } else {
      setVolume(0)
      videoElement.current.pause();
    }
  }, [props.isPlaying]);


  let videoType = props.video && props.video.type;
  let videoBgClasse = 'video-bg';
  if (props.isPlaying) {
    videoBgClasse += ' active';
  }


  return (
    <div className={videoBgClasse}>
      {!props.isPlaying && (
        <img alt='image' src={props.imageUrl} className='thumbnail' />
      )}

      <video
        controls={true}
        controlsList="nodownload noplaybackrate" 
        disablePictureInPicture ={true}
        ref={videoElement}
        className='video'
        id='video'
        preload='metadata'
      
      >
        <source src={previousUrl} type={videoType} />
      </video>
    
      {props.isPlaying && (
        <>
          <button onClick={props.onVideoExit} className='exit-button'>
            EXIT
          </button>
        </>
      )}
    </div>
  );
};

export default VideoPlayer;